import * as React from 'react';
import { useDispatch } from 'react-redux';

import { CommunicationActionButton, CommunicationImage, CommunicationLayout } from '../../components/Communication';
import { StageLayout } from '../../components/StageLayout';
import { setActiveStep } from '../../actions/consultationRequest';
import { EActiveConsultationModal } from '../../types/redux/states';
import { NBSP } from '../../constants/symbols';

export const SERVICE_AVAILABILITY_SUBSCRIBE = {
  title: `Сервис временно не${NBSP}работает`,
  image: `https://static.cdn-cian.ru/frontend/e2e-form-assets/splash_screens/error.svg`,
  message: `Делаем его${NBSP}лучше — совсем скоро всё${NBSP}запустим`,
  activatorLabel: `Заказать консультацию`,
};

export const ServiceAvailabilitySubscribeContainer: React.FC = () => {
  const dispatch = useDispatch();
  const openLeaveContactsModal = () => {
    dispatch(setActiveStep(EActiveConsultationModal.ChoosingConsultationType));
  };

  return (
    <StageLayout>
      <CommunicationLayout
        title={SERVICE_AVAILABILITY_SUBSCRIBE.title}
        message={SERVICE_AVAILABILITY_SUBSCRIBE.message}
        image={
          <CommunicationImage src={SERVICE_AVAILABILITY_SUBSCRIBE.image} alt={SERVICE_AVAILABILITY_SUBSCRIBE.title} />
        }
        action={
          <CommunicationActionButton onClick={openLeaveContactsModal}>
            {SERVICE_AVAILABILITY_SUBSCRIBE.activatorLabel}
          </CommunicationActionButton>
        }
      />
    </StageLayout>
  );
};
